import * as React from 'react';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';
import { Col, Row, Tabs } from 'antd';
const TabPane = Tabs.TabPane;
import { connect } from "react-redux";

import { ContextService } from 'src/core/services/context.service';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { ProductServiceTypeEditorController } from 'src/app/products/product-service-types/parts/product-service-type-editor.controller';
import { TourItineraryProductController } from 'src/app/products/tour-itineraries/form/parts/tour-itinerary-products.controller';
import { ProductContractsController } from 'src/app/products/products/form/parts/product-contracts.controller';
import { TourItineraryDateListController } from 'src/app/products/tour-itineraries/tour-itinerary-date/list/tour-itinerary-date-list.controller';
import { DepartureDates } from './parts/tour-itinerary-departure-dates.view';

interface PropsFromState {
	category?: ProductCategorySummary;
}

interface Props {
	mode: ControlMode;
	model: TourItineraryItem;
	setBusy: (busy: boolean) => void;
	contextService: ContextService;
	product: ProductItem;
}

@observer
class TourItineraryFormView extends React.Component<Props & PropsFromState, {}> {
	@resolve
	private configService: ConfigurationService;

	public render(): React.ReactNode {
		const { contextService, mode, model, product, setBusy, category } = this.props;

		if (!product || !model || !this.configService.configuration) {
			return null;
		}
		const translations = model.dynamicProperties['translations'];
		const displayNames = model.dynamicProperties['displayName'];

		const array: TabLanguageModel[] = [
			{
				title: 'Title',
				dynamicProperties: displayNames,
				required: true
			},
			{
				title: 'Description',
				dynamicProperties: translations,
				rows: 5
			}
		];

		const tourWithContracts = category && category.canHaveContracts;
		const tabBody = tourWithContracts
			? (
				<TabPane tab="Contracts" key="Contracts">
					<ProductContractsController
						defaultLanguage={this.configService.configuration.defaultLanguage}
						mode={mode}
						model={model}
						setBusy={setBusy}
						contextService={contextService}
					/>
				</TabPane>
			)
			: null;

		return (
			<React.Fragment>
				<div className='card p-3'>
					<Tabs>
						<TabPane tab="Itinerary" key="Itinerary">
							<Row gutter={16}>
								<Col xs={24} md={12}>
									<TabLanguageController
										dynamicProperties={array}
										mode={mode}
										setBusy={setBusy}
										isRichTextBox={false}
										model={model}
									/>
								</Col>
								<Col xs={24} md={12}>
									<ProductServiceTypeEditorController
										categoryId={product.categoryId}
										mode={mode}
										onChanged={this.onChangeService}
										required={true}
										setBusy={setBusy}
										value={model.productServiceTypeId}
									/>
									<DepartureDates mode={mode} model={model} />
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<TourItineraryProductController
										contextService={contextService}
										mode={mode}
										model={model}
										product={product}
										setBusy={setBusy}
									/>
								</Col>
							</Row>
						</TabPane>
						{tabBody}
						<TabPane tab="Groups dates" key="Dates">
							<TourItineraryDateListController
								languageCode={this.configService.configuration.defaultLanguage}
								mode={mode}
								model={model}
								setBusy={setBusy}
								contextService={contextService}
							/>
						</TabPane>
					</Tabs>
				</div>
			</React.Fragment>
		);
	}

	private onChangeService = (service: ProductServiceTypeSummary) => {
		const { model } = this.props;
		if (service != null) {
			model.productServiceTypeId = service.id;
			model.productServiceTypeDisplayName = service.displayName;
		} else {
			model.productServiceTypeId = null;
			model.productServiceTypeDisplayName = null;
		}
	}
}

const mapStateToProps = (
	state: IApplicationState,
	props: Props
): PropsFromState => {
	const product = state.otherLoadedEntities.find(e => e.entity == props.product.entity);
	return {
		category: product ? (product as ProductItem).category : undefined,
	};
};

const connected = connect(mapStateToProps)(TourItineraryFormView);
export { connected as TourItineraryFormView };



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/form/tour-itinerary.view.tsx